import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { TdDialogService, TdLoadingService } from '@covalent/core';

import { AuthenticationService, TokensService } from '../services';
import { StorageService } from '../services';

import 'rxjs/add/operator/toPromise';

@Component({
    selector: 'login',
    providers: [TokensService, StorageService],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    username: string;
    password: string;
    returnUrl: string;
    clients: any[] = [];
    storages: any[] = [];
    token: any;
    selectedClient: any;
    storageName: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private _dialogService: TdDialogService,
        private authenticationService: AuthenticationService,
        private tokensService: TokensService,
        private storageService: StorageService,
        private loadingService: TdLoadingService) { }

    ngOnInit() {
        this.authenticationService.logout();
        // reset login status
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    select() {
        this.loadingService.register();
        this.tokensService.changeClient(this.token, this.token.clientId)
            .subscribe(
            data => {
                this.token = data;
                this.authenticationService.setToken(this.token);
                this.loadPermissions();
                console.log("Client selected: " + this.token.clientId);
                this.selectStorage();
                this.loadingService.resolve();
                this.router.navigate([this.returnUrl]);
            },
            error => {
                this._dialogService.openAlert({ message: error.message, title: 'Warnung' });
                this.loadingService.resolve();
            });
        
    }

    selectStorage() {
        this.authenticationService.setStorageName(this.storageName);
    }

    checkClients() {
        this.loadingService.register();
        this.tokensService.getClients(this.token)
            .subscribe(
            data => {
                this.clients = data;
                this.loadingService.resolve();
                if (this.clients.length == 1) {
                    this.authenticationService.setToken(this.token);
                    this.loadPermissions();
                  //  this.router.navigate([this.returnUrl]);
                }
            },
            error => {
                this._dialogService.openAlert({ message: error.message, title: 'Warnung' });
                this.loadingService.resolve();
            });
    }

    checkStorages() {
        this.loadingService.register();
        this.storageService.getStorages(this.token)
            .subscribe(
            data => {
                this.storages = data;
                this.loadingService.resolve();
                if (this.storages.length == 1) {
                //    this.router.navigate([this.returnUrl]);
                }
            },
            error => {
                this._dialogService.openAlert({ message: error.message, title: 'Warnung' });
                this.loadingService.resolve();
            });
    }

    async loadPermissions(): Promise<void> {
        try {
            let userInfo = await this.tokensService.getPermissions(this.token).toPromise();
            this.authenticationService.setUserInfo(userInfo);
        } catch (error) {
            console.log("could not load user permissions");
        } finally {
        }
    }

    login() {
        this.loadingService.register();
        this.tokensService.login(this.username, this.password)
            .subscribe(
            data => {
                this.token = data;
                this.authenticationService.setToken(this.token);
                this.loadingService.resolve();
                this.checkClients();
                this.checkStorages();
            },
            error => {
                this._dialogService.openAlert({ message: error.message, title: 'Warnung' });
                this.loadingService.resolve();
            });
    }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/login/login.component.ts